"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Duplicate_exports = {};
__export(Duplicate_exports, {
  default: () => Duplicate_default
});
module.exports = __toCommonJS(Duplicate_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.49999 2.8999C4.06405 2.8999 2.89999 4.06396 2.89999 5.4999V14.4999C2.89999 15.9358 4.06405 17.0999 5.49999 17.0999H6.89999V18.4999C6.89999 19.9358 8.06405 21.0999 9.49999 21.0999H18.5C19.9359 21.0999 21.1 19.9358 21.1 18.4999V9.4999C21.1 8.06396 19.9359 6.8999 18.5 6.8999H17.1V5.4999C17.1 4.06396 15.9359 2.8999 14.5 2.8999H5.49999ZM15.9 6.8999V5.4999C15.9 4.7267 15.2732 4.0999 14.5 4.0999H5.49999C4.7268 4.0999 4.09999 4.7267 4.09999 5.4999V14.4999C4.09999 15.2731 4.7268 15.8999 5.49999 15.8999H6.89999V9.4999C6.89999 8.06396 8.06405 6.8999 9.49999 6.8999H15.9ZM8.09999 9.4999C8.09999 8.7267 8.7268 8.0999 9.49999 8.0999H18.5C19.2732 8.0999 19.9 8.7267 19.9 9.4999V18.4999C19.9 19.2731 19.2732 19.8999 18.5 19.8999H9.49999C8.7268 19.8999 8.09999 19.2731 8.09999 18.4999V9.4999ZM17.5 14.5999C17.8314 14.5999 18.1 14.3313 18.1 13.9999C18.1 13.6685 17.8314 13.3999 17.5 13.3999H14.6V10.4999C14.6 10.1685 14.3314 9.8999 14 9.8999C13.6686 9.8999 13.4 10.1685 13.4 10.4999V13.3999H10.5C10.1686 13.3999 9.90001 13.6685 9.90001 13.9999C9.90001 14.3313 10.1686 14.5999 10.5 14.5999L13.4 14.5999V17.4999C13.4 17.8313 13.6686 18.0999 14 18.0999C14.3314 18.0999 14.6 17.8313 14.6 17.4999L14.6 14.5999H17.5Z",
      fill: "currentColor"
    }
  )
);
const SvgDuplicate = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Duplicate_default = SvgDuplicate;
